import { useCallback, useState } from "react";
import TableFC, {
  TableFCBodyProps,
  TableFCFooterProps,
} from "../../../components/table/Table";
import TableHeader from "../../../components/table/TableHeader";
import InsertGrouping from "../form/InsertGrouping";
import { useDeleteGrouping, useGetGroupingDetails } from "../network/resolver";
import { ModalFC } from "../../../components/modal/Modal";
import { Button } from "@mui/material";
import GroupingHistory from "./GroupingHistory";
import { IGroupingDetail } from "../network/ProdukDetail.type";

interface GroupingProps {
  id: any;
}

export default function Grouping({ id }: GroupingProps) {
  const [showModal, setShowModal] = useState<
    "InsertGrouping" | "InsertHistory" | undefined
  >(undefined);
  const [selectedGrouping, setSelectedGrouping] = useState<
    undefined | IGroupingDetail
  >(undefined);
  const [selected, setSelected] = useState<any[]>([]);
  const initTotal = useCallback(() => {
    return selected.reduce((acc, item) => {
      return acc + item.value.initial_stock;
    }, 0);
  }, [selected]);
  const currentTotal = useCallback(() => {
    return selected.reduce((acc, item) => {
      return acc + item.value.current_stock;
    }, 0);
  }, [selected]);
  const [idGrouping, setIdGrouping] = useState<number | undefined>(undefined);
  const [page, setPage] = useState(1);
  const { mutate: mutateDelete, isLoading: loadingDelete } =
    useDeleteGrouping();
  const { data: dataRawGroupingDetail, isLoading: loadingFetchDetails } =
    useGetGroupingDetails({
      product_id: id,
      page,
      perPage: 10,
    });
  const dataGroupingDetail = dataRawGroupingDetail?.data.data.data;
  const header: string[] = [
    "No",
    "Nama Group",
    "Jumlah Awal",
    "Jumlah Sekarang",
    "",
    "",
  ];
  const body: TableFCBodyProps[] = [
    {
      key: "group_name",
    },
    {
      key: "initial_stock",
    },
    {
      key: "current_stock",
    },
    {
      key: "",
      newComponent: (e) => {
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setIdGrouping(e.id);
              setShowModal("InsertHistory");
            }}
          >
            Detail
          </Button>
        );
      },
    },
    {
      key: "",
      newComponent: (e) => {
        return (
          <Button
            color="error"
            variant="outlined"
            size="small"
            onClick={() => {
              if (confirm("Apakah Anda Yakin ?")) {
                mutateDelete({ id: e.id });
              }
            }}
            disabled={loadingDelete}
          >
            Hapus
          </Button>
        );
      },
    },
  ];
  const footer: TableFCFooterProps[] = [
    {
      offset: 2,
      text: "Total",
      contents: [initTotal(), currentTotal()],
    },
  ];

  return (
    <div>
      <TableHeader
        title=""
        addButton
        onClickAdd={() => setShowModal("InsertGrouping")}
      />
      <TableFC
        showCheckBox
        showIndex
        loading={loadingFetchDetails}
        data={dataGroupingDetail}
        head={header}
        body={body}
        footer={footer}
        totalRows={dataRawGroupingDetail?.data?.data?.total}
        onChecked={(e: any) => {
          setSelected(e);
        }}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => {
          setSelectedGrouping(e);
          setShowModal("InsertGrouping");
        }}
      />
      <ModalFC
        open={showModal === "InsertGrouping"}
        onClose={() => {
          setShowModal(undefined);
          setSelectedGrouping(undefined);
        }}
      >
        <InsertGrouping id={id} grouping={selectedGrouping} />
      </ModalFC>
      <ModalFC
        open={showModal === "InsertHistory"}
        onClose={() => setShowModal(undefined)}
      >
        <GroupingHistory grouping_product_id={idGrouping} />
      </ModalFC>
    </div>
  );
}
